import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "../axios-orders";
import {
  OrderInvitationDetailsDTO,
  OrderInvitationOfferRequest,
  OrderInvitationOfferResponse,
} from "../types";
import { queryKeys } from "./queryKeys";

const onGetInvitationDetails = async (
  token: string
): Promise<OrderInvitationDetailsDTO> => {
  const { data } = await axios.get(`/order-invitations/${token}`);
  return data;
};

export const useGetInvitationDetails = (token: string | undefined) =>
  useQuery<OrderInvitationDetailsDTO>({
    queryKey: [queryKeys.ORDER_INVITATION, token],
    queryFn: () => onGetInvitationDetails(token!),
    enabled: !!token,
    retry: false,
  });

const onSubmitInvitationOffer = async (
  body: OrderInvitationOfferRequest
): Promise<OrderInvitationOfferResponse> => {
  const { data } = await axios.post("/order-invitations/offer", body);
  return data;
};

export const useSubmitInvitationOffer = (
  onSuccess: (res: OrderInvitationOfferResponse) => void,
  onError: (error?: unknown) => void
) =>
  useMutation({
    mutationFn: onSubmitInvitationOffer,
    onSuccess,
    onError,
  });
